import type { ZoneResult } from '../../gen/ejot/roofing/v1/types';

export function zoneFixingPresentation(zone: ZoneResult | undefined) {
  const etaComponentMode = zone?.resistance_basis === 'FIXING_RESISTANCE_BASIS_ETA_COMPONENT_CHARACTERISTIC';
  return {
    etaComponentMode,
    resistanceLabel: etaComponentMode
      ? 'Characteristic component resistance'
      : 'Governing design resistance',
    resistance: etaComponentMode
      ? zone?.governing_characteristic_resistance
      : zone?.governing_design_resistance,
    densityLabel: etaComponentMode
      ? 'Required characteristic component density'
      : 'Theoretical density',
    theoreticalDensity: zone?.layout?.theoretical_density,
    installableDensity: etaComponentMode ? undefined : zone?.layout?.installable_density,
    spacing: etaComponentMode ? undefined : zone?.layout?.spacing_in_overlap,
    fixingsPerMetre: etaComponentMode ? undefined : zone?.layout?.fixings_per_metre,
    totalFixings: zone?.layout?.total_fixings,
    utilization: etaComponentMode ? undefined : zone?.utilization,
    adjustmentReasons: zone?.layout?.adjustment_reasons ?? [],
  };
}
